import { Component, Input, OnInit } from '@angular/core';
import { ApprovedJobFunction } from '../../models/accommodations-interactions';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-approved-job-function',
    template: `
    @for (
      essentialJFs of approvedJobFunction.essentialJobFunctions; track
      essentialJFs; let i = $index) {
      <div
        class="tw-w-full"
        >
        <div class="tw-flex tw-justify-between tw-items-center tw-mb-2">
          <div>
            <span class="tw-font-bold">
              <mat-icon class="tw-text-green-500 check-icon">check</mat-icon>
              {{ 'Job Function' | translation: translationRequest }}
            </span>
            <span> - </span>
            <span>{{ essentialJFs.approvedTask | translation: translationRequest }}</span>
          </div>
          <div class="tw-flex tw-items-center " (click)="toggleExpand(i)">
            <mat-icon
              tabindex="0"
              class="expand-icon"
            [attr.aria-label]="
              expandState[i]
                ? 'Collapse this section'
                : 'Expand approved job functions'
            "
              >{{ expandState[i] ? 'expand_less' : 'expand_more' }}</mat-icon
              >
            </div>
          </div>
          <div [hidden]="!expandState[i]">
            <div class="tw-flex tw-flex-wrap tw-w-full">
              <div class="tw-w-full md:tw-w-[33%]">
                <h4 class="tw-font-bold tw-mb-2 header">{{ 'IMPACTED PERIOD' | translation: translationRequest }}</h4>
                @if (essentialJFs.impactStart) {
                  <app-value
                    layout="row"
                    class="tw-w-full"
                    label="BEGIN"
                    [value]="essentialJFs.impactStart | format : 'date'"
                    [translationNeeded]="false"
                  ></app-value>
                }
                @if (essentialJFs.impactEnd) {
                  <app-value
                    layout="row"
                    class="tw-w-full"
                    label="END"
                    [value]="essentialJFs.impactEnd | format : 'date'"
                    [translationNeeded]="false"
                  ></app-value>
                }
                @if (essentialJFs.impactedLongTerm) {
                  <app-value
                    layout="row"
                    class="tw-w-full"
                    label="LONG TERM"
                    [value]="essentialJFs.impactedLongTerm"
                  ></app-value>
                }
              </div>
              <div class="tw-w-full md:tw-w-[33%]">
                <h4 class="tw-font-bold tw-mb-2 header">{{ 'RESTRICTION PERIOD' | translation: translationRequest }}</h4>
                @if (essentialJFs.restrictionBegin) {
                  <app-value
                    layout="row"
                    class="tw-w-full"
                    label="BEGIN"
                    [value]="essentialJFs.restrictionBegin | format : 'date'"
                    [translationNeeded]="false"
                  ></app-value>
                }
                @if (essentialJFs.restrictionEnd) {
                  <app-value
                    layout="row"
                    class="tw-w-full"
                    label="END"
                    [value]="essentialJFs.restrictionEnd | format : 'date'"
              	    [translationNeeded]="false"
                  ></app-value>
                }
                @if (essentialJFs.restrictionLongTerm) {
                  <app-value
                    layout="row"
                    class="tw-w-full"
                    label="LONG TERM"
                    [value]="essentialJFs.restrictionLongTerm"
                  ></app-value>
                }
              </div>
              <div class="tw-w-full md:tw-w-[33%]">
              <h4 class="tw-font-bold tw-mb-2 header">{{ 'DETAILS' | translation: translationRequest }}</h4>
                @if (essentialJFs.medicalNeeded) {
                  <app-value
                    layout="row"
                    label="MEDICAL NEEDED"
                    class="tw-w-full"
                    [value]="essentialJFs.medicalNeeded"
                  ></app-value>
                }
                @for (
                  cognitiveRestriction of essentialJFs.cognitiveRestriction
                  ; track
                  cognitiveRestriction) {
                  <div
                    >
                    @if (cognitiveRestriction) {
                      <app-value
                        layout="row"
                        label="COGNITIVE RESTRICTIONS"
                        class="tw-w-full"
                        [value]="cognitiveRestriction"
                      ></app-value>
                    }
                  </div>
                }
                @for (
                  physicalRestriction of essentialJFs.physicalRestriction
                  ; track
                  physicalRestriction) {
                  <div
                    >
                    @if (physicalRestriction) {
                      <app-value
                        layout="row"
                        label="PHYSICAL RESTRICTIONS"
                        [value]="physicalRestriction"
                      ></app-value>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="tw-flex tw-flex-wrap tw-w-full tw-mt-4">
              <div class="tw-w-full md:tw-w-[34%]">
                <h4 class="tw-font-bold tw-mb-2 header">{{ 'MAJOR LIFE ACTIVITIES' | translation: translationRequest }}</h4>
                @for (majorLifeActivity of essentialJFs.majorLifeActivity; track majorLifeActivity) {
                  <div
                    >
                    @if (majorLifeActivity) {
                      <app-value
                        layout="col"
                        [value]="majorLifeActivity"
                      ></app-value>
                    }
                  </div>
                }
              </div>
              <div class="tw-w-full md:tw-w-[66%]">
            	<h4 class="tw-font-bold tw-mb-2 header">{{ 'BODY PARTS IMPACTED' | translation: translationRequest }}</h4>
                @for (bodyPart of essentialJFs.bodyPartImpacted; track bodyPart) {
                  <div>
                    @if (bodyPart) {
                      <app-value
                        layout="col"
                        [value]="bodyPart"
                      ></app-value>
                    }
                  </div>
                }
              </div>
            </div>
            <div
              class="tw-flex tw-flex-wrap tw-w-full tw-mt-4 restriction-description"
              >
          	<h4 class="tw-font-bold tw-mb-2 label">{{ 'RESTRICTION DESCRIPTION' | translation: translationRequest }}:</h4>
              <span class="tw-mb-2">{{ essentialJFs.restrictionDescription | translation: translationRequest}}</span>
            </div>
          </div>
          <mat-divider aria-hidden="true"></mat-divider>
        </div>
      }
    `,
    styles: [
        `
      .check-icon {
        position: relative;
        top: 6px;
      }

      .header {
        background-color: #f1f4f7;
        padding: 8px 0px;
        display: flex;
        justify-content: space-between;
        align-items: left;
      }

      .label {
        padding: 8px 0px;
        display: flex;
        justify-content: space-between;
        align-items: left;
      }

      .restriction-description {
        display: flex;
        align-items: center;
      }

      .restriction-description .label {
        margin-right: 8px;
      }

      .expand-icon {
        color: var(--color-slate);
        cursor: pointer;
      }

      @media (max-width: 768px) {
        .header {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    `,
    ],
    standalone: false
})
export class ApprovedJobFunctionComponent implements OnInit {
  @Input()
  approvedJobFunction: ApprovedJobFunction;

  expandState: boolean[] = [];
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'ApprovedJobFunction',
    subGroup: 'ApprovedJobFunction',
  });
  ngOnInit(): void {
    this.approvedJobFunction.essentialJobFunctions.forEach((val, ind) => {
      this.expandState[ind] = false;
    });
  }

  toggleExpand(itemIndex: any) {
    this.expandState[itemIndex] = !this.expandState[itemIndex];
  }
}
